<template>
<div ref="platrenewadd" style="position:relative;">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">新增续费</span>
        <div class="TTL-button TTL-btn-option">
        <el-badge :value="renewlist.length > 1 ? renewlist.length : ''" class="item">
        <el-button @click="submitData">提交数据</el-button>
        </el-badge>
        </div>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="clearAll">清空已填模板</el-button>
        </div>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="addRenew">新增模板</el-button>
        </div>
        <div class="TTL-button TTL-btn-option">
        <el-button type="del" @click="GoBackPets(false)">返回续费记录</el-button>
        </div>
    </div>
    
    <div>
        <div class="TTL-form-submit-box " v-for="(item,index) in renewlist" :key="index">
            <div class="TTL-form-submit-box-title">续费模板-{{index+1}}</div>
            <div class="TTL-button TTL-btn-option">
            <el-button type="del" v-if="index > 0" @click.stop="delrenew(index)">删除</el-button>
            </div>
            <el-form :inline="false">
                <el-form-item>
                    <label class="TTL-form-label">商户名称<i>* </i></label>
                    <div class="TTL-input TTL-form-input">
                    <el-select v-model="item.shopid" placeholder="请搜索商户" 
                    filterable  
                    remote 
                    reserve-keyword 
                    @input="changeSelect(index)"
                    :remote-method="GetShopLists"
                    @change="changeShops(index)"
                    >
                    <el-option v-for="(t,i) in item.shoplist" :key="i" :label="t.shopname" :value="t.id" />
                    </el-select>
                    </div>
                    <span class="TTL-search">（可按关键字、商家注册手机搜索商户）</span>
                    <div class="TTL-search-shop top20">
                    <div class="TTL-search-shop-in" v-if="item.shopid > 0">
                    <span class="TTL-search-details">商户ID：{{item.shopid}}</span>
                    <span class="TTL-search-details">商户名称：{{item.shopname}}</span>
                    <span class="TTL-search-details">商户手机：{{item.phone}}</span>
                    </div>
                    </div>
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">备注</label>
                    <div class="TTL-input TTL-form-input">
                    <el-input type="textarea" v-model="item.note" class="width350" :autosize="{ minRows: 3, maxRows: 6}" />
                    </div>
                </el-form-item>
                <el-form-item class="top40">
                    <div class="TTL-button TTL-btn-option"><el-button @click="addmenus(index)">新增续费功能</el-button></div>
                    <div class="TTL-button TTL-btn-option"><el-button @click="settingtimes(index)">设置时间</el-button></div>
                    <div class="TTL-cost-money"><i>续费金额合计：</i>￥{{item.cost}}</div>
                </el-form-item>
                <el-form-item>
                    <div class="TTL-table top20">
                    <el-table :data="item.detail" stripe="true" empty-text="">
                        <el-table-column label="续费功能" align="center">
                            <template #default="scope">
                                <div class="TTL-input TTL-form-input"><el-input v-model="scope.row.menu_name" placeholder="请选择续费功能" readonly @click="GetMenus(index,scope.$index)" /></div>
                            </template>
                        </el-table-column>
                        <el-table-column label="续费时长" align="center">
                            <template #default="pscope">
                                <div class="TTL-input TTL-append TTL-form-input">
                                <el-input v-model="pscope.row.time" placeholder="请填写续费时常">
                                <template #append>
                                <div class="TTL-select">
                                <el-select v-model="pscope.row.timetype" placeholder="请选择时间类型">
                                <el-option v-for="(tt,ii) in timetypelist" :key="ii" :value="tt.id" :label="tt.name" />
                                </el-select>
                                </div>
                                </template>
                                </el-input>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="续费续费金额" align="center">
                            <template #default="pscope">
                                <div class="TTL-input TTL-append TTL-form-input">
                                <el-input v-model="pscope.row.cost" placeholder="请选择续费金额" @change="changeTotals">
                                <template #append>元</template>
                                </el-input>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="备注" align="center">
                            <template #default="pscope">
                                <div class="TTL-input TTL-form-input"><el-input v-model="pscope.row.note" placeholder="请填写备注" /></div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" align="center">
                            <template #default="pscope">
                                <div class="TTL-button">
                                <el-button type="del" @click="delrenewdetail(index,pscope.$index)">删除</el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    </div>
                </el-form-item>
            </el-form>
        </div>
    </div>

    <!-- 设置续费时间 -->
    <el-dialog v-model="settingtimetypes.view" title="设置续费时间" width="350">
        <div class="TTL-input TTL-append TTL-form-input">
            <el-input v-model="settingtimetypes.value" placeholder="请填写续费时常">
                <template #append>
                    <div class="TTL-select">
                        <el-select v-model="settingtimetypes.timetype" placeholder="请选择时间类型">
                        <el-option v-for="(tt,ii) in timetypelist" :key="ii" :value="tt.id" :label="tt.name" />
                        </el-select>
                    </div>
                </template>
            </el-input>
        </div>
        <div class="TTL-page-box top50" style="justify-content:end">
        <div class="TTL-page TTL-page-right">
            <div class="TTL-button TTL-btn-option">
            <el-button type="del" @click="settingtimetypes.view=false">取消</el-button>
            </div>
            <div class="TTL-button TTL-btn-option">
            <el-button @click="saveTimeSetting">确定</el-button>
            </div>
        </div>
        </div>
    </el-dialog>

    <!-- 查看付费功能信息 -->
    <el-drawer v-model="authview" title="查看收费功能" size="45%">
        <div class="TTL-input width300"><el-input placeholder="功能名称" v-model="menukey" @input="changeMenusname" clearable /></div>
        <div class="TTL-search-list top20">
            <div class="TTL-table top20">
                <el-table :data="menulist" stripe="true" empty-text="">
                    <template v-slot:empty><el-empty description="暂无数据" /></template>
                    <el-table-column prop="id" label="id" align="center" />
                    <el-table-column prop="menu_name" label="功能名称" align="center" min-width="160" />
                    <el-table-column prop="cost" label="续费金额 / 月" align="center" />
                    <el-table-column label="操作" align="center" min-width="140">
                        <template #default="scope">
                            <div class="TTL-button">
                            <el-button @click="selectMenus(scope.$index)">选择</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
    </el-drawer>


</div>
</template>

<script>
import INTERFACE_MODEL_SHOP from '@/Interface/Shop/index';
import INTERFACE_MODEL_RENEW from '@/Interface/Renew/renew';
export default {
    components:{},
    data() {
        return {
            addlimit: 10,           //单次新增限制
            changeSelectIndex:'',   //会员选择序号
            timetypelist:[{id:1,name:'日'},{id:2,name:'月'},{id:3,name:'年'},{id:4,name:'K'},{id:5,name:'M'},{id:6,name:'G'}],
            settingtimetypes: {
                index:'',
                timetype:'',
                value:'',
                view:false
            },
            renewlist:[             //版本列表
                {shopid:'', shopname:'', phone:'', shoplist:[], cost:'', note:'', detail:[]}
            ],      
            shopindex:'',
            menuindex:'',
            authview:false,
            menukey:'',
            basemenulist:[],
            menulist:[],
        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {

        /** 页数初始化 **/
        OnloadMethod() {
            
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {          //兄弟组件跳转至当前组件时进行询问操作
                
            }else if(data.reload) {   //浏览器重新刷新时执行的操作
                
            }else {
                this.ParseDataFromBrowser();
            } 
        },


        /** 提交数据 **/
        submitData() {
            //调整提交数据
            var data=[];
            var info;
            var obj;
            for(var i=0;i<this.renewlist.length;i++) {
                obj=this.renewlist[i];
                info={shopid:obj.shopid, shopname:obj.shopname, phone:obj.phone, cost:obj.cost, note:obj.note, detail:obj.detail};
                data.push(info);
            }
            data=JSON.stringify(data);

            var loadingobj=this.$refs.platrenewadd;
            this.$loading.openloading(loadingobj);  //加载等待动画
            INTERFACE_MODEL_RENEW.ADD_RENEW({data:data}).then((res) => {
                this.$loading.closeloading(loadingobj);
                if(res.status > 0) return false;
                this.resetParam(); //重置当前数据
                this.$notice({title:'成功提示',message:'数据提交成功',type:'success'});
                this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
            });
        },


        /** 新增续费功能 **/
        addmenus(index) {
            var renewinfo={menu_id:'' ,menu_name:'', timetype:2, time:'', cost:'', note:''};
            this.renewlist[index].detail.push(renewinfo);
        },


        /** 设置功能续费时间 **/
        settingtimes(index) {
            this.settingtimetypes.index=index;
            this.settingtimetypes.timetype=1;
            this.settingtimetypes.value='';
            this.settingtimetypes.view=true;
        },


        /** 保存设置时长信息 **/
        saveTimeSetting() {
            if(this.settingtimetypes.timetype=='') {this.$notice({title:'消息提示',message:'请选择续费时长类型',type:'warning'});;return false;}
            if(this.settingtimetypes.value=='') {this.$notice({title:'消息提示',message:'请选择续费时长',type:'warning'});;return false;}
            var index=this.settingtimetypes.index;
            var obj=this.renewlist[index].detail;
            for(var i in obj) {
                obj[i].timetype=this.settingtimetypes.timetype;
                obj[i].time=this.settingtimetypes.value;
            }
            this.settingtimetypes.view=false;
        },


        /**删除续费功能**/
        delrenewdetail(index,did) {
            this.renewlist[index].detail.splice(did,1);
        },


        /** 关键字搜索费用信息 **/
        changeMenusname() {
            this.menulist=[];
            var key=this.menukey;
            var obj;
            var menu_name;
            var index=-1;
            for(var i in this.basemenulist) {
                obj=this.basemenulist[i];
                menu_name=obj.menu_name;
                if(!key || key=='') { //空字符串搜索
                    this.menulist.push(obj);
                }else { //非空字符串搜索
                    index=menu_name.indexOf(key);
                    if(index > -1) this.menulist.push(obj);
                }
            }
        },


        /** 选中菜单信息 **/
        selectMenus(index) {
            this.authview=false;
            var obj=this.menulist[index];
            var menuobj=this.renewlist[this.shopindex].detail[this.menuindex];
            menuobj.menu_id=obj.id;
            menuobj.menu_name=obj.menu_name;
            menuobj.timetype=2;
            menuobj.time=1;
            menuobj.cost=obj.cost;

            //调整续费金额合计
            this.changeTotals();
        },

        /////////////////////////////////////////////////////////////////
        ////////////////////////////////////////////////////////////////
        //关联基础数据加载

        /** 调整续费金额合计 **/
        changeTotals() {
            var totals=0;
            var renewobj;
            var menuobj;
            for(var i=0;i < this.renewlist.length;i++) {
                totals=0;
                renewobj=this.renewlist[i];
                for(var ii=0;ii < renewobj.detail.length;ii++) {
                    menuobj=renewobj.detail[ii];
                    menuobj.cost > 0 ? totals+=parseFloat(menuobj.cost) : "";
                }
                renewobj.cost=totals;
            }

        },


        /** 获取付费功能信息 **/
        GetMenus(shopindex,menuindex) {
            this.shopindex=shopindex;
            this.menuindex=menuindex;
            this.authview=true;
            this.basemenulist=[];  

            INTERFACE_MODEL_SHOP.GET_AUTH_RENEW().then((res) => {
                 if(res.status > 0) return false;
                 this.basemenulist=res.data;
                 this.menulist=res.data;
            });
        },


        /** 切换店铺信息 **/
        changeShops(index) {
            var shopid=this.renewlist[index].shopid;
            var shoplist=this.renewlist[index].shoplist;
            var obj;
            for(var i in shoplist) {
                if(shoplist[i].id==shopid) obj=shoplist[i];
            }
            this.renewlist[index].shopname=obj.shopname;
            this.renewlist[index].phone=obj.phone;
        },


        /** 获取账号模板 **/
        GetShopLists(keyname) {
            if(!keyname || keyname=='') return false; //传入空字符串时不执行搜索
            var param={key:keyname,p:1,rollpage:1000000};
            INTERFACE_MODEL_SHOP.GET_PLATFORM_SHOP(param).then((res) => {
                 if(res.status > 0) return false;
                 var shops=res.data.list;
                 this.renewlist[this.changeSelectIndex].shoplist=[];
                 this.renewlist[this.changeSelectIndex].shoplist=shops;
            });
        },


        /** 标记当前正在选择的会员 **/
        changeSelect(index) {
            this.changeSelectIndex=index;
        },


        /** 清空当前数据 **/
        clearAll() {
            this.$confirm.confirm(
                '您是否确定要删除当前所有续费信息 ？',
                '删除提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
            ).then(()=> {
                this.resetParam();
                this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
            }).catch(()=> {

            });
        },

        
        /** 新增品种模板信息 **/
        addRenew() {
            if(this.renewlist.length >= this.addlimit) {
                this.$notice({title:'消息提示',message:'单次添加续费版本数量最多不要超过'+this.addlimit+'个',type:'warning'});
                return false;
            }

            var renewinfo={shopid:'', shopname:'', phone:'', shoplist:[], cost:'', note:'', detail:[]};
            this.renewlist.push(renewinfo);
            this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
        },


        /** 删除单个品种信息 **/
        delrenew(index) {
            this.renewlist.splice(index,1);
            this.SaveDataToBrowser(); //保存编辑完成之后的数据信息到浏览器
        },


        /** 数据保存到浏览器 **/
        SaveDataToBrowser() {
            var data=JSON.stringify(this.renewlist);
            localStorage.setItem('addprenewdata',data);
        },

        /** 从浏览器取数据解析 **/
        ParseDataFromBrowser() {
            var data=localStorage.getItem('addprenewdata');
            data ? data : data=[];
            !data || data=='' || data==[] ? this.resetParam() : this.renewlist=JSON.parse(data);
        },

        /** 返回宠物管理组件 **/
        GoBackPets(isdellocal) {
            var navinfo={name:'账号续费设置',labelentry:'PlatFormCost',components:'PlatFormCost',isshow:false};
            var data={Method:''};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },

        /** 重置加载数据 **/
        resetParam() {
            this.renewlist=[];
            var renewinfo={shopid:'', shopname:'', phone:'', shoplist:[], cost:'', note:'', detail:[]};
            this.renewlist.push(renewinfo);
            this.SaveDataToBrowser();
        },

    },
}
</script>
<style scoped>
.TTL-image-box-large {cursor: pointer;width:auto !important;}
.TTL-image-box-large .el-image {width:120px;height:120px;display: inline-block;border-radius: 5px;}
.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.TTL-radio .el-radio__label) {display: inline-flex !important;align-items: center !important;}
.TTL-radio .el-image {width:18px;height: 18px;}
.TTL-form-label i {font-weight: normal;font-size: 12px;}
.TTL-cost-money {font-size:13px;margin-right:20px;font-weight: 550;letter-spacing: 1px;color:crimson;}
.TTL-cost-money i {font-style: normal;font-weight: normal;letter-spacing: 2px;font-size:13px;color:#333333;}
.TTL-search {font-size: 12px;color: crimson;margin-left:10px;letter-spacing: 2px;display:inline-block;}
::v-deep(.el-input-group--append .el-input-group__append .el-select .el-input .el-input__wrapper) {box-shadow: none !important;}
::v-deep(.el-input-group--append .el-input-group__append .el-select .el-input.is-focus .el-input__wrapper) {box-shadow: none !important;}
::v-deep(.TTL-select .el-input__inner) {text-align: center;}
.TTL-search-shop {display:inline-block;width:100%;}
.TTL-search-shop-in {display: inline-block;padding:15px;border-radius: 6px;background-color: #F2F6FC;width: 15%;border:1px dashed #D4D7DE;}
.TTL-search-details {font-size: 12px;letter-spacing: 2px;display:inline-block;width:100%;color: #666666;}
.TTL-search-list {display: inline-block;width:100%;height:88%;overflow-y:auto;}
.TTL-search-list::-webkit-scrollbar {width:0;}
.TTL-menus-infos {display: inline-flex;width:100%;align-items: center;position:relative;padding:20px 0;}
.TTL-menus-menuname {width:calc(45% - 30px);font-size: 13px;line-height:21px;color:#666666;letter-spacing: 2px;}
.TTL-menus-cost {font-size:12px;font-weight: 550;color:red;width:40%;text-align: center;}
.TTL-menus-btn {cursor: pointer;width:22px;height:22px;background-image:url(@/assets/icon/right-blue.png);background-repeat: no-repeat;background-size: 22px;background-position: center;}
</style>